import { ChangeDetectionStrategy, Component, contentChildren, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultFormValueControl } from '@coin/shared/core/util-helpers';
import { TemplateWithValueDirective } from '@coin/shared/core/util-directives';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'coin-radio-pill',
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './radio-pill.component.html',
  styleUrl: './radio-pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioPillComponent<T = unknown> extends DefaultFormValueControl<T> {
  readonly options = contentChildren(TemplateWithValueDirective);
  readonly variant = input<Variant>(VARIANTS[0]);
  readonly disabledExplanation = input<string>();

  public selectOption(value: T): void {
    if (value === this.viewValue()) return;

    this.updateValue(value);
    this.markAsTouched();
  }
}

export const VARIANTS = ['primary', 'secondary'] as const;
export type Variant = (typeof VARIANTS)[number];
